import classNames from 'classnames';
import React from 'react';

import Button, {ButtonProps, ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';

export type DataFrameActionButtonProps = Pick<ButtonProps, 'icon' | 'disabled' | 'onClick'> & {
  title: string | null;
  toggled?: boolean;
};

export default function DataFrameActionButton(props: DataFrameActionButtonProps): JSX.Element {
  return (
    <Tooltip text={props.title}>
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        className={classNames('u-mini-spacing-left', Boolean(props.toggled) && 'is-active')}
        disabled={props.disabled}
        icon={props.icon}
        onClick={props.onClick}
        size={ButtonSize.MINI}
      />
    </Tooltip>
  );
}
